import { XGrid } from "@AMIEWEB/Common";
import { orderDataActions } from "@AMIEWEB/Order/Store/Order.redux";
import { selectOrderChangeHistory } from "@AMIEWEB/Order/Store/Order.selectors";
import { Box } from "@mui/material";
import { GridColumns } from "@mui/x-data-grid-pro";
import TimelineIcon from "@mui/icons-material/Timeline";
import { LayoutGrid, LayoutGridItem } from "app/layout/LayoutGrid";
import React, { useState } from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { changeHistoryColumns } from "./helper";
import { useTranslation } from "react-i18next";
import { ChangeHistoryTimelineModal } from "@AMIEWEB/Common/ChangeHistoryTimeline";
import type { IXGridBulkActionButton } from "@AMIEWEB/Common/XGrid/Toolbar/XGridToolbar";
const useStyles = makeStyles()({
  container: {
    padding: '24px 0px',
  },
});

export const OrderChangeHistoryWrapper = () => {
  const { id: orderId } = useParams<{ id: string }>();
  
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { promiseInProgress } = usePromiseTracker({ area: 'order-change-history' });
  
  const rows = useSelector(selectOrderChangeHistory) ?? [];
  const [columns, setColumns] = useState<GridColumns>(changeHistoryColumns(t));
  const [sortModel, setSortModel] = React.useState<any>([
    {
      field: 'created',
      sort: 'desc',
    },
  ]);
  const [timelineModalOpen, setTimelineModalOpen] = React.useState(false);

  const rightActions: IXGridBulkActionButton[] = React.useMemo(() => {
    if (!rows?.length) return [];
    return [
      {
        KeyId: 'timeline-visualization',
        Icon: TimelineIcon,
        tooltipProps: {
          tooltipContent: t('order.changeHistoryTab.timelineVisualization'),
          disabled: false,
        },
        onClick: () => setTimelineModalOpen(true),
      },
    ];
  }, [rows?.length, t]);

  const fetchOrderChangeHistoryData = () => {
    dispatch(orderDataActions.getOrderChangeHistory({ orderId, pageSize: 1000, pageNumber: 1 }));
  };

  React.useEffect(() => {
    fetchOrderChangeHistoryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LayoutGrid>
      <LayoutGridItem xs={12}>
        <Box className={classes.container}>
          <XGrid
            columns={columns}
            rows={rows}
            headerHeight={45}
            autoHeight
            disableSelectionOnClick
            loading={promiseInProgress}
            sortModel={sortModel}
            onSortModelChange={model => setSortModel(model)}
            toolbarProps={{
              refreshButton: true,
              refreshGrid: () => fetchOrderChangeHistoryData(),
              resetColumns: () => setColumns(changeHistoryColumns(t)),
              rightActions,
            }}
          />
          <ChangeHistoryTimelineModal
            open={timelineModalOpen}
            onClose={() => setTimelineModalOpen(false)}
            title={t('order.changeHistoryTab.timelineModalTitle')}
            historyData={rows}
          />
        </Box>
      </LayoutGridItem>
    </LayoutGrid>
  );
};
